import { render } from "./MeasurePotentialOnOffStationForm.vue?vue&type=template&id=15ed97f4&scoped=true"
import script from "./MeasurePotentialOnOffStationForm.vue?vue&type=script&lang=js"
export * from "./MeasurePotentialOnOffStationForm.vue?vue&type=script&lang=js"

import "@/assets/stationForm.css?vue&type=style&index=0&id=15ed97f4&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15ed97f4"]])

export default __exports__